module.exports = __webpack_public_path__ + "img/live-casino-banner.9c25697.gif";